<script>
import options from './GroupDetails.options'
  export default options
</script>

<template>
  <article class="kb-group-details" >
    <a :href="link">
      <div class="kb-group-details__header">
        <div class="kb-group-details__header-symbol" :class="colorTheme">
          <div v-html="svgIcon"></div>
        </div>
        <div class="kb-group-details__header-info">
          <div class="kb-group-details__header-labels">
            <span class="kb-group-details__header-label" v-if="type">{{ type }}</span>
            <span class="kb-group-details__header-label" v-if="updates">
              <span class="kb-group-details__header-label-circle"></span>
              {{ updates }} {{ getLabel('newUpdates') }}
            </span>
          </div>
          <h2 class="kb-group-details__header-title">{{ title }}</h2>
        </div>
      </div>
    </a>

    <div class="kb-group-details__tags">
      <div class="kb-group-details__tags-tag">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 12"><path fill="#3C3C3C" fill-rule="evenodd" d="M4.5 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 6.15c0-1.203.91-2.15 2-2.15 1.09 0 2 .947 2 2.15v2.85h.5V7.993A2.496 2.496 0 0 1 13 5.5c1.381 0 2.5 1.117 2.5 2.493V11h-1v.5H16V7.993A2.996 2.996 0 0 0 13 5a3 3 0 0 0-2.898 2.216C9.66 6.488 8.89 6 8 6c-.889 0-1.66.488-2.102 1.216A3 3 0 0 0 3 5C1.344 5 0 6.34 0 7.993V11.5h1.5V11h-1V7.993A2.496 2.496 0 0 1 3 5.5c1.381 0 2.5 1.117 2.5 2.493V11.5H6V8.65ZM13 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 .5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-3.75-.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" clip-rule="evenodd"/></svg>
        <span v-if="memberCount || memberCount === 0">
          {{ memberCount }} {{ getLabel('members') }}
        </span>
        <span v-else class="kb-group-details__tags-tag__skeleton"></span>
      </div>
      <div  class="kb-group-details__tags-tag">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#3C3C3C" fill-rule="evenodd" d="M10.706 8.746h.024a.65.65 0 0 0 .62-.644V1.395a.651.651 0 0 0-.651-.649H1.024a.651.651 0 0 0-.651.651v6.047h1.674v-.558H.931V1.397a.093.093 0 0 1 .093-.093H10.7a.093.093 0 0 1 .093.093v6.704a.09.09 0 0 1-.091.089H3.072c-2.231-.002-2.7 1.263-2.7 2.324v.279h.558v-.28c0-1.209.68-1.767 2.14-1.767h7.635Zm4.272-3.349h-2.884v.558h2.884a.093.093 0 0 1 .093.093v5.489h-1.117v.558h1.675V6.048a.65.65 0 0 0-.651-.65Zm-4.795 7.442h2.748c2.229 0 2.698 1.265 2.698 2.326v.279h-.558v-.28c0-1.209-.68-1.767-2.14-1.767H5.296a.652.652 0 0 1-.646-.642V9.49h.558v3.26a.09.09 0 0 0 .092.09h4.883Z" clip-rule="evenodd"/></svg>
        <span v-if="postsCount || postsCount === 0">
          {{ postsCount }} {{ getLabel('posts') }}
        </span>
        <span v-else class="kb-group-details__tags-tag__skeleton"></span>
      </div>
    </div>

    <div class="kb-group-details__actions">
      <button v-on:click="handleLeaveGroup" class="kb-group-details__actions-leave">{{ getLabel('leaveGroupButtonLabel') }}</button>
    </div>
  </article>
</template>
